import { FC, useState } from 'react';
import { Icon } from '../Icon';
import { RadioButton, UnselectedIcon } from './styles';

export interface IRadioOption {
  value: string | number;
  label: string | React.ReactNode;
  disabled?: boolean;
}

export interface IRadioButtons {
  options: IRadioOption[];
  defaultValue?: string | number;
  onSelect?: (value?: string | number) => void;
}

const RadioButtons: FC<IRadioButtons> = ({ options, defaultValue, onSelect }) => {
  const [selectedOption, setSelectedOption] = useState<string | number | undefined>(defaultValue);

  const onChange = (option: IRadioOption) => {
    if (option.disabled) {
      return;
    }
    if (onSelect) {
      onSelect(option.value);
    }
    setSelectedOption(option.value);
  };
  return (
    <div>
      {options.map((option) => (
        <RadioButton onClick={() => onChange(option)} $disabled={option.disabled}>
          {selectedOption === option.value ? (
            <Icon icon='confirmacao'
              customSize={15}
              className="selectedIcon"
            />
          ) : (
            <UnselectedIcon />
          )}
          <div>{option.label}</div>
        </RadioButton>
      ))}
    </div>
  );
};

export default RadioButtons;
